import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/create/tenant.create.mutation.gql"
import type {
  TenantCreateMutation,
  TenantCreateMutationVariables,
} from "@/v2-backoffice-client/tenant/create/__types__/tenant.create.mutation"

type Options = MutationHookOptions<
  TenantCreateMutation,
  TenantCreateMutationVariables
>

export function useTenantCreateMutation(options?: Options) {
  return useMutation<TenantCreateMutation, TenantCreateMutationVariables>(
    mutation,
    options,
  )
}
